/** @jsxImportSource @emotion/react */
import React, { useMemo } from "react";
import styled from "@emotion/styled";
import TickIcon from "../../../img/trade-history/vector-335.svg?react";
import { GlobalStore } from "store/global/GlobalStore";

interface FilterCheckboxProps {
  checked: boolean;
  isRowHoveredOn: boolean;
}

export const FilterCheckbox: React.FC<FilterCheckboxProps> = ({ checked, isRowHoveredOn }) => {
  const theme = GlobalStore.useState(s => s.theme);
  const checkboxBorderColor = useMemo(() => {
    if (checked) return "transparent";
    if (isRowHoveredOn) return theme.radiochecktoggle.focus;
    return theme.radiochecktoggle.inner.disabled;
  }, [
    checked,
    isRowHoveredOn,
    theme.radiochecktoggle.focus,
    theme.radiochecktoggle.inner.disabled,
  ]);

  return (
    <CheckboxContainer borderColor={checkboxBorderColor} checked={checked}>
      {checked && <TickIcon />}
    </CheckboxContainer>
  );
};

// Sub-components

const CheckboxContainer = styled.span<{ borderColor: string; checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  width: 22px;
  min-width: 22px;
  border-width: 2px;
  border-color: ${props => props.borderColor};
  border-style: solid;
  border-radius: 8px;
  background-color: ${props =>
    props.checked ? props.theme.radiochecktoggle.selected : "transparent"};
  margin-left: 10px;
`;
